module.exports = {"320117001":"永阳街道","320117002":"柘塘街道","320117003":"东屏街道","320117004":"石湫街道","320117005":"洪蓝街道","320117101":"白马镇","320117106":"晶桥镇","320117107":"和凤镇","320117400":"溧水开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320117.json
// module id = 836
// module chunks = 0